import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoCrashIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_crash"}/>
}
